import { StateUtils } from '@spartacus/core';
import { PrePrintedLabel } from '../../../../../core/model';
import { PyStateUtils } from '../../../../../core/state';
import {
  CartEntryPrePrintedLabelActionTypes,
  LoadPrePrintedInnerPackageQuantityRequired,
  LoadPrePrintedInnerPackageQuantityRequiredFail,
  LoadPrePrintedInnerPackageQuantityRequiredSuccess,
  LoadPrePrintedOptions,
  LoadPrePrintedOptionsFail,
  LoadPrePrintedOptionsSuccess,
} from '../actions/cart-entry-pre-printed-label.action';
import { CartActions } from '../actions/index';
import { PRE_PRINTED_LABEL, PrePrintedLabelsState } from '../cart-state';

export const initialOptionsState: PrePrintedLabel[] = undefined;

function optionsReducer(
  state: StateUtils.LoaderState<PrePrintedLabel[]>,
  action: CartActions.CartEntryPrePrintedLabelActions | StateUtils.LoaderAction
): StateUtils.LoaderState<PrePrintedLabel[]> {
  switch (action.type) {
    case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedOptionsSuccess:
      return action?.payload?.options;
    case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedOptionsFail:
      return undefined;
  }
  return state;
}

export const innerPackageQuantityRequiredState = false;

function innerPackageQuantityRequiredReducer(
  state: StateUtils.LoaderState<boolean>,
  action: CartActions.CartEntryPrePrintedLabelActions | StateUtils.LoaderAction
): StateUtils.LoaderState<boolean> {
  switch (action.type) {
    case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedInnerPackageQuantityRequiredSuccess:
      return action?.payload?.innerPackageQuantityRequired;
    case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedInnerPackageQuantityRequiredFail:
      return undefined;
  }
  return state;
}

export const initialPrePrintedState: PrePrintedLabelsState = undefined;

export function prePrintedLabelReducer(
  state: PrePrintedLabelsState = {},
  action: StateUtils.LoaderAction
): PrePrintedLabelsState {
  if (action.meta && action.meta.entityType === PRE_PRINTED_LABEL) {
    switch (action.type) {
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedOptions:
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedOptionsFail:
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedOptionsSuccess: {
        const payload = (<LoadPrePrintedOptions | LoadPrePrintedOptionsFail | LoadPrePrintedOptionsSuccess>action).payload;
        const currentOptionsState = {
          ...(state[payload?.entry?.entryNumber]?.options ?? PyStateUtils.initialLoaderState),
        };
        return {
          ...state,
          [payload?.entry?.entryNumber]: {
            ...state[payload?.entry?.entryNumber],
            options: PyStateUtils.loaderReducer<StateUtils.LoaderState<PrePrintedLabel[]>>(PRE_PRINTED_LABEL, optionsReducer)(
              currentOptionsState,
              action
            ),
          },
        };
      }
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedInnerPackageQuantityRequired:
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedInnerPackageQuantityRequiredFail:
      case CartEntryPrePrintedLabelActionTypes.LoadPrePrintedInnerPackageQuantityRequiredSuccess: {
        const payload = (<
          | LoadPrePrintedInnerPackageQuantityRequired
          | LoadPrePrintedInnerPackageQuantityRequiredFail
          | LoadPrePrintedInnerPackageQuantityRequiredSuccess
        >action).payload;
        const currentInnerPackageQuantityRequiredState = {
          ...(state[payload?.entry?.entryNumber]?.innerPackageQuantityRequired ?? PyStateUtils.initialLoaderState),
        };
        return {
          ...state,
          [payload?.entry?.entryNumber]: {
            ...state[payload?.entry?.entryNumber],
            innerPackageQuantityRequired: PyStateUtils.loaderReducer<StateUtils.LoaderState<boolean>>(
              PRE_PRINTED_LABEL,
              innerPackageQuantityRequiredReducer
            )(currentInnerPackageQuantityRequiredState, action),
          },
        };
      }
      case CartEntryPrePrintedLabelActionTypes.ClearPrePrintedLabels:
        return undefined;
    }
  }
  return state;
}
